import React, { type ReactNode } from 'react';
import { Card, CardContent } from '@core-ui/Components/ui/card';
import { Skeleton } from '@core-ui/Components/ui/skeleton';
import { cn } from '@core-ui-lib/utils';

interface MetricCardProps {
  title: string;
  value: string | number;
  icon?: ReactNode;
  loading?: boolean;
  className?: string;
}

export default function MetricCard ({
  title,
  value,
  icon,
  loading = false,
  className,
}: MetricCardProps): React.JSX.Element {
  if (loading) {
    return (
      <Card className={cn('bg-card/50 border-border', className)}>
        <CardContent className="p-5">
          <div className="flex items-center justify-between mb-3">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-8 w-8 rounded-lg" />
          </div>
          <Skeleton className="h-8 w-16" />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className={cn('bg-card/50 border-border transition-all hover:bg-card/70', className)}>
      <CardContent className="p-5">
        <div className="flex items-center justify-between mb-3">
          <span className="text-sm font-medium text-muted-foreground">{title}</span>
          {icon !== undefined && (
            <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
              {icon}
            </div>
          )}
        </div>
        <div className="text-3xl font-bold">{value}</div>
      </CardContent>
    </Card>
  );
}
